import AsyncFlow from '../asyncFlow';

export default AsyncFlow({
    store: 'unlink-license',
    initialState: {
        isOpen: false,
        isUnlinked: '',
        statusAction: 'READY',
    },
    actions: ['UNLINK_LICENSE', 'SHOW_UNLINK_DIALOG'],
}).extend({
    reducer: (state, action, { types }) => {
        switch (action.type) {
            case types.UNLINK_LICENSE_SUCCESS:
                return {
                    ...state,
                    isUnlinked: action.payload.isUnlinked
                };

            case types.SHOW_UNLINK_DIALOG:
                return {
                    ...state,
                    isOpen: !state.isOpen
                };


            default:
                return state;
        }
    },
    creators: ({ types }) => ({

        unlinkLicenseRequest: (pk) => ({
            type: types.UNLINK_LICENSE_REQUEST,
            payload: { pk },
        }),
        unlinkLicenseSuccess: ({ isUnlinked }) => ({
            type: types.UNLINK_LICENSE_SUCCESS,
            payload: { isUnlinked },
        }),
        unlinkLicenseFailed: error => ({ type: types.UNLINK_LICENSE_FAILED, error: true, payload: { error } }),

        showDisassociaDialog: () => ({
            type: types.SHOW_UNLINK_DIALOG,
        }),
    }),
});
